import sacService from "@/services/sac";

export default {
  state: {
    classList: [],
    currentClass: null,
    currentLecture: null,
    teacherProfile: null,
    classTournamentState: {
      tournamentId: null,
      selectedRoundNumber: null,
    },
    leaderboardModalOpen: false,
    offlineMode: false,
  },

  getters: {
    getCurrentClass: (state) => state.currentClass,
    getCurrentLecture: (state) => state.currentLecture,
    getClassList: (state) => state.classList,
    getTeacherProfile: (state) => state.teacherProfile,
    getClassTournamentState: (state) => state.classTournamentState,
    getLeaderboardModalOpen: (state) => state.leaderboardModalOpen,
    getOfflineMode: (state) => state.offlineMode,
  },

  mutations: {
    setCurrentClass(state, currentClass) {
      state.currentClass = {
        ...currentClass,
      };
    },
    setCurrentLecture(state, currentLecture) {
      state.currentLecture = {
        ...currentLecture,
      };
    },
    setClassList(state, classList) {
      state.classList = [...classList];
    },
    setTeacherProfile(state, teacherProfile) {
      // Handle null case (when clearing profile)
      if (!teacherProfile) {
        state.teacherProfile = null;
        return;
      }

      // Add isAdmin property based on teacher's name
      const fullName = `${teacherProfile.firstName}${teacherProfile.lastName}`;
      const adminNames = [
        "MinhLe",
        "NeilWright",
        "BrettTindall",
        "AndrewBird",
        "JordanBrown",
      ];
      const isAdmin = adminNames.includes(fullName);

      state.teacherProfile = {
        ...teacherProfile,
        isAdmin,
      };
    },
    clearTeacherProfile(state) {
      state.teacherProfile = null;
      state.currentClass = null;
      state.currentLecture = null;
      state.classList = [];

      // Also clear SAC service token to prevent unauthorized access
      sacService.logout();
    },
    setClassTournamentState(state, classTournamentState) {
      state.classTournamentState = {
        ...state.classTournamentState,
        ...classTournamentState,
      };
    },
    setLeaderboardModalOpen(state, isOpen) {
      state.leaderboardModalOpen = isOpen;
    },
    setOfflineMode(state, offlineMode) {
      state.offlineMode = offlineMode;
    },
  },

  actions: {
    updateCurrentClass({ commit }, currentClass) {
      commit("setCurrentClass", currentClass);
    },
    updateCurrentLecture({ commit }, currentClass) {
      commit("setCurrentLecture", currentClass);
    },
    updateClassList({ commit }, classList) {
      commit("setClassList", classList);
    },
    updateTeacherProfile({ commit }, teacherProfile) {
      commit("setTeacherProfile", teacherProfile);
    },
    updateClassTournamentState({ commit }, classTournamentState) {
      commit("setClassTournamentState", classTournamentState);
    },
    updateLeaderboardModalOpen({ commit }, isOpen) {
      commit("setLeaderboardModalOpen", isOpen);
    },
    updateOfflineMode({ commit }, offlineMode) {
      commit("setOfflineMode", offlineMode);
    },
  },
};
